/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NumberCircle06Icon16Light } from './NumberCircle06Icon16Light';
import { NumberCircle06Icon16Regular } from './NumberCircle06Icon16Regular';
import { NumberCircle06Icon16Solid } from './NumberCircle06Icon16Solid';
import { NumberCircle06Icon20Light } from './NumberCircle06Icon20Light';
import { NumberCircle06Icon20Regular } from './NumberCircle06Icon20Regular';
import { NumberCircle06Icon20Solid } from './NumberCircle06Icon20Solid';
import { NumberCircle06Icon24Regular } from './NumberCircle06Icon24Regular';
import { NumberCircle06Icon24Solid } from './NumberCircle06Icon24Solid';
import { NumberCircle06Icon32Regular } from './NumberCircle06Icon32Regular';
import { NumberCircle06Icon64Regular } from './NumberCircle06Icon64Regular';
var sizes = {
    16: {
        light: NumberCircle06Icon16Light,
        regular: NumberCircle06Icon16Regular,
        solid: NumberCircle06Icon16Solid,
    },
    20: {
        light: NumberCircle06Icon20Light,
        regular: NumberCircle06Icon20Regular,
        solid: NumberCircle06Icon20Solid,
    },
    24: {
        regular: NumberCircle06Icon24Regular,
        solid: NumberCircle06Icon24Solid,
    },
    32: {
        regular: NumberCircle06Icon32Regular,
    },
    64: {
        regular: NumberCircle06Icon64Regular,
    },
};
export var NumberCircle06Icon = forwardRef('NumberCircle06Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
